export default {"src":"/_next/static/media/facebook.2d597944.svg","height":17,"width":8,"blurWidth":0,"blurHeight":0};